import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { NoteButtonModule } from '../../notes/note-button/note-button.module';

import { InsuranceManagementRoutingModule } from './insurance-management-routing.module';
import { InsuranceManagementComponent } from './insurance-management.component';
import { NoteCompactModule } from '../../notes/note-compact/note-compact.module';

import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InsuranceCoverageModule } from '../insurance-coverage/insurance-coverage.module';
import { PatientModule } from '../../patient/patient.module';
import {ValidValueSelectModule} from '../../../tdo-controls/validvalueselect/validvalueselect-module';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import {DxButtonModule} from "devextreme-angular";

@NgModule({
  declarations: [
    InsuranceManagementComponent,
  ],
  providers: [DatePipe],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NoteButtonModule,
        InsuranceManagementRoutingModule,
        NoteCompactModule,
        InsuranceCoverageModule,
        PatientModule,

        // material
        MatDividerModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatRadioModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTooltipModule,
        ValidValueSelectModule,
        TdoControlsModule,
        DxButtonModule,
    ]
})
export class InsuranceManagementModule { }
